import * as React from "react"
import { Link } from "gatsby"

import { StaticImage } from "gatsby-plugin-image";

import * as S from './styles';

export default function Trustpilot() {
  return (
    <S.Container>
      <Link rel="noreferrer" to="https://uk.trustpilot.com/review/ujoose.com" target="_blank">
        <StaticImage
          src={`../../images/trustpilot.png`}
          alt="Trustpilot"
          placeholder="blurred"
          layout="fixed"
          width={201}
          height={100}
        />
      </Link>
    </S.Container>
  )
}